import {PlusIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {routes} from '@/utilities/constants/routes'
import {generatePath} from 'react-router-dom'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {
    StyledAddRelationButtonLink,
    StyledMedicalRecordHeader
} from '@/features/medical-records/components/medical-record-header/style'
import {MedicalRecordDateRangeFilter} from '@/features/medical-records/components/medical-record-date-range-filter/MedicalRecordDateRangeFilter'
import {MedicalRecordOperatorFilter} from '@/features/medical-records/components/medical-record-operator-filter/MedicalRecordOperatorFilter'
import {MedicalRecordReportTypeFilter} from '@/features/medical-records/components/medical-record-report-type-filter/MedicalRecordReportTypeFilter'
import {MedicalRecordProjectFilter} from '@/features/medical-records/components/medical-record-project-filter/MedicalRecordProjectFilter'
import {usePermissions} from '@/features/auth/store/store'
import {MedicalRecordAggregatedPrintModal} from '../medical-record-aggregated-print-modal/MedicalRecordAggregatedPrintModal'

export const MedicalRecordHeader = ({patientId}: {patientId: string}) => {
    const {t} = useTranslation()
    const permissions = usePermissions()

    return (
        <StyledMedicalRecordHeader>
            <Flexbox gap={2}>
                <MedicalRecordDateRangeFilter />
                <MedicalRecordOperatorFilter />
                <MedicalRecordReportTypeFilter />
                <MedicalRecordProjectFilter patientId={patientId} />
            </Flexbox>
            {permissions?.medicalRecords.write && (
                <Flexbox gap={2} align="center">
                    <MedicalRecordAggregatedPrintModal patientId={patientId} />
                    <StyledAddRelationButtonLink
                        variant="primaryNeutral"
                        to={generatePath(routes.CREATE_MEDICAL_REPORT.path, {id: patientId})}
                    >
                        <PlusIcon />
                        {t('commons:report', {count: 1})}
                    </StyledAddRelationButtonLink>
                </Flexbox>
            )}
        </StyledMedicalRecordHeader>
    )
}
